import * as colors from './colors';
export default colors;
//# sourceMappingURL=index.js.map